import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VAutocomplete,{attrs:{"items":_vm.usersList,"item-value":"id","item-text":"fullName","label":_vm.labelValue,"clearable":_vm.clearable,"rules":[_vm.requiredCheck()],"readonly":_vm.readonly,"append-icon":_vm.readonly ? null : '$dropdown',"outlined":"","hide-details":_vm.hideDetails ? _vm.hideDetails : false},model:{value:(_vm.userIdValue),callback:function ($$v) {_vm.userIdValue=$$v},expression:"userIdValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }